export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtPPOdhadokruh';
export const NAME = 'OkruhPp';
